// SurveyContext.tsx
import  { createContext, useContext } from 'react';
import { SurveyContextType } from './types';

export const SurveyContext = createContext<SurveyContextType | null>(null);

export const useSurvey = () => {
  const context = useContext(SurveyContext);
  if (!context) {
    throw new Error('Survey components must be used within a Survey component');
  }
  return context;
};